<template>
  <div id="ranking_list" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
    <van-row>
      <van-col span="24" class="ranking_list_bg">
        <van-col span="24">
          <van-nav-bar
              left-arrow
              placeholder
              safe-area-inset-top
              class="ranking_list_bg_bar"
              @click-left="onClickLeft"
          >
            <template #title>
              <van-tabs v-model="ranking_active" @click="onClickRankingActive" line-width="20px" title-active-color="#ffffff" title-inactive-color="#D9B29A">
                <van-tab :title="$t('column.rich_list')" name="wealth"/>
                <van-tab :title="$t('column.anchor_list')" name="charm"/>
              </van-tabs>
            </template>
          </van-nav-bar>
        </van-col>
        <van-col span="22" offset="1" class="ranking_list_top_day">
          <van-tabs type="card" v-model="day_active" @click="onClickRankingDay">
            <van-tab :title="$t('column.day_list1')" name="daily"></van-tab>
            <van-tab :title="$t('column.monthly_list1')" name="monthly"></van-tab>
            <van-tab :title="$t('column.ranking_all')" name="total"></van-tab>
          </van-tabs>
        </van-col>
        <van-col span="22" offset="1" class="ranking_list_top_height">
          <van-col span="8" class="ranking_list_1" >
            <img src="../assets/img/ranking_coin_1.png" class="ranking_list_avatar_img" @click="JumpUserinfo(list.length > 0 ? list[0].user_id : 0)"/>
            <van-image
                width="12vw"
                height="12vw"
                round
                class="ranking_list_1_avatar"
                fit="cover"
                :src="list[0].head_image"
                v-if="list.length > 0"
                @click="JumpUserinfo(list.length > 0 ? list[0].user_id : 0)"
            />
            <van-col span="22" offset="1" class="ranking_list_name1" v-if="list.length > 0">{{ list[0].nick_name }} </van-col>
            <van-col span="22" offset="1" class="ranking_list_coin" v-if="list.length > 0">
              <div class="ranking_coin_sex_container">
                <img :src="list[0].sex === 1 ? sex1 : sex2"/>
                <span class="ranking_coin_sex_number">{{ list[0].age }}</span>
              </div>
              <img :src="list[0].user_level" v-if="ranking_active === 'wealth'"/>
              <img :src="list[0].charm_level" v-else/>
            </van-col>
            <van-col span="22" offset="1" class="ranking_list_sum" v-if="list.length > 0"> {{ list[0].ticket }} </van-col>
            <van-col span="22" offset="1" class="ranking_list_follow" v-if="list.length > 0 && list[0].is_follow === 0">
              <van-button round size="mini" plain hairline color="#4B1B04" @click="followBtn(0)">{{ $t('column.follow') }}</van-button>
            </van-col>
          </van-col>
          <van-col span="8" class="ranking_list_2">
            <img src="../assets/img/ranking_coin_2.png" class="ranking_list_avatar_img2" @click="JumpUserinfo(list.length > 1 ? list[1].user_id : 0)"/>
            <van-image
                width="13vw"
                height="13vw"
                round
                class="ranking_list_2_avatar"
                fit="cover"
                :src="list[1].head_image"
                v-if="list.length > 1"
                @click="JumpUserinfo(list.length > 1 ? list[1].user_id : 0)"
            />
            <van-col span="22" offset="1" class="ranking_list_name" v-if="list.length > 1">{{ list[1].nick_name }} </van-col>
            <van-col span="22" offset="1" class="ranking_list_coin" v-if="list.length > 1">
              <div class="ranking_coin_sex_container">
                <img :src="list[1].sex === 1 ? sex1 : sex2"/>
                <span class="ranking_coin_sex_number">{{ list[1].age }}</span>
              </div>
              <img :src="list[1].user_level" v-if="ranking_active === 'wealth'"/>
              <img :src="list[1].charm_level" v-else/>
            </van-col>
            <van-col span="22" offset="1" class="ranking_list_sum" v-if="list.length > 1"> {{ list[1].ticket }}</van-col>
            <van-col span="22" offset="1" class="ranking_list_follow" v-if="list.length > 1 && list[1].is_follow === 0">
              <van-button round size="mini" plain hairline color="#4B1B04" @click="followBtn(1)">{{ $t('column.follow') }}</van-button>
            </van-col>
          </van-col>
          <van-col span="8" class="ranking_list_3">
            <img src="../assets/img/ranking_coin_3.png" class="ranking_list_avatar_img3" @click="JumpUserinfo(list.length > 2 ? list[2].user_id : 0)"/>
            <van-image
                width="13vw"
                height="13vw"
                round
                class="ranking_list_2_avatar"
                fit="cover"
                :src="list[2].head_image"
                v-if="list.length > 2"
                @click="JumpUserinfo(list.length > 2 ? list[2].user_id : 0)"
            />
            <van-col span="22" offset="1" class="ranking_list_name" v-if="list.length > 2">{{ list[2].nick_name }}</van-col>
            <van-col span="22" offset="1" class="ranking_list_coin" v-if="list.length > 2">
              <div class="ranking_coin_sex_container">
                <img :src="list[2].sex === 1 ? sex1 : sex2"/>
                <span class="ranking_coin_sex_number">{{ list[2].age }}</span>
              </div>
              <img :src="list[2].user_level" v-if="ranking_active === 'wealth'"/>
              <img :src="list[2].charm_level" v-else/>
            </van-col>
            <van-col span="22" offset="1" class="ranking_list_sum" v-if="list.length > 2"> {{ list[2].ticket }}</van-col>
            <van-col span="22" offset="1" class="ranking_list_follow" v-if="list.length > 2 && list[2].is_follow === 0">
              <van-button round size="mini" plain hairline color="#4B1B04" @click="followBtn(2)">{{ $t('column.follow') }}</van-button>
            </van-col>
          </van-col>
        </van-col>
      </van-col>
      <van-col span="24" class="ranking_list_cell">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('other.there_is_no_more')"
            @load="onLoad"
        >
          <van-cell v-for="(item,i) in list" :key="i" v-if="i > 2">
            <van-col span="24" class="ranking_list_item">
              <van-col span="2" offset="1" class="ranking_list_item_i"> {{ i + 1 }} </van-col>
              <van-col span="4" class="ranking_list_item_i">
                <van-image
                    width="10vw"
                    height="10vw"
                    round
                    class="ranking_list_item_avatar"
                    fit="cover"
                    :src="item.head_image"
                    @click="JumpUserinfo(item.user_id)"
                />
                <div v-if="item.avatar_frame_url">
                  <picture v-if="isWebP(item.avatar_frame_url)"  @click="JumpUserinfo(item.user_id)">
                    <source :srcset="item.avatar_frame_url" type="image/webp" >
                    <img :src="item.avatar_frame_url" class="ranking_list_item_avata_frame_webp_list" />
                  </picture>
                  <div :id='"popular_svga"+item.user_id' class="ranking_list_item_avata_frame" @click="JumpUserinfo(item.user_id)" v-else></div>
                </div>
              </van-col>
              <van-col span="12" class="ranking_list_item_center">
                <van-col span="24" class="ranking_list_item_center_name">
                  <span class="ranking_list_item_center_nick_name">{{ item.nick_name }}</span>
                  <div class="ranking_list_sex_container">
                    <img :src="item.sex === 1 ? sex1 : sex2"/>
                    <span class="ranking_list_sex_number">{{ item.age }}</span>
                  </div>
                  <img :src="item.user_level" v-if="ranking_active === 'wealth'"/>
                  <img :src="item.charm_level" v-else/>
                </van-col>
                <van-col span="24" class="ranking_list_item_center_text">{{ $t('column.contribute') }}: {{ item.ticket }} {{ diamonds_name }} </van-col>
              </van-col>
              <van-col span="4" class="ranking_list_item_follow">
                <van-button round size="mini" hairline color="#FFFA2D" v-if="item.is_follow === 0" @click="followBtn(i)">{{ $t('column.follow') }}</van-button>
              </van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-col span="24" class="ranking_list_user">
        <van-col span="22" offset="1" class="ranking_all_list_item">
          <van-col span="3" class="ranking_all_list_item_number">{{ rank_user.rank ? rank_user.rank : '' }}</van-col>
          <van-col span="4" class="ranking_all_list_item_avatar">
            <van-image
                width="10vw"
                height="10vw"
                round
                :src="rank_user.head_image"
                fit="cover"
            />
            <div v-if="rank_user.avatar_frame_url">
              <picture v-if="isWebP(rank_user.avatar_frame_url)" @click="JumpUserinfo(rank_user.user_id)">
                <source :srcset="rank_user.avatar_frame_url" type="image/webp" >
                <img :src="rank_user.avatar_frame_url" class="ranking_list_item_avata_frame_webp" />
              </picture>
              <div :id='"popular_svga"+rank_user.user_id' class="ranking_list_item_avata_frame" @click="JumpUserinfo(rank_user.user_id)" v-else></div>
            </div>
          </van-col>
          <van-col span="16" class="ranking_list_item_center">
            <van-col span="24" class="ranking_list_item_center_name">
              <span class="ranking_list_item_center_nick_name">{{ rank_user.nick_name }}</span>
              <div class="ranking_list_sex_container">
                <img :src="rank_user.sex === 1 ? sex1 : sex2"/>
                <span class="ranking_list_sex_number">{{ rank_user.age }}</span>
              </div>
              <img :src="rank_user.user_level"/>
            </van-col>
            <van-col span="24" class="ranking_list_item_center_text">{{ $t('column.contribute') }}: {{ rank_user.ticket }} {{ diamonds_name }} </van-col>
          </van-col>
        </van-col>
      </van-col>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Dialog, Toast} from "vant";
import SVGA from "svgaplayerweb";
import {judgeIosAndroid} from "../assets/js/models";

export default {
  data() {
    return {
      day_active: 'daily',
      ranking_active: 'wealth',
      list: [],
      finished: false,
      coin9: require('../assets/img/coin9.png'),
      coin11: require('../assets/img/coin11.png'),
      rank_user:{
        age: undefined,
        avatar_frame_url: '',
        charm_level: 0,
        head_image:'',
        in_range:'',
        nick_name: undefined,
        rank: undefined,
        score: undefined,
        sex: 1,
        ticket: undefined,
        user_id: undefined,
        user_level: 0
      },
      diamonds_name: undefined,
      loading: false,
      page: 1,
      sex1: require('../assets/img/sex1-1.png'),
      sex2: require('../assets/img/sex2-1.png'),
      loading_request: false, // 接口是否在请求中
      touchStartX: 0, // 触摸开始X坐标
      touchStartY: 0, // 触摸开始Y坐标
      touchEndX: 0, // 触摸结束X坐标
      touchEndY: 0, // 触摸结束Y坐标
      day_tabs: ['daily', 'monthly', 'total'] // 日榜tab顺序
    }
  },
  created () {
    this.convert()
  },
  methods: {
    isWebP(url) {
      if (!url) return false
      // 去除查询参数和哈希
      const cleanUrl = url.split('?')[0].split('#')[0]
      // 获取扩展名
      const extension = cleanUrl.split('.').pop().toLowerCase()
      return extension === 'webp'
    },
    onLoad() {
      // 异步更新数据
      if (this.page > 1) {
        this.convert()
      }
    },
    followBtn(i) {
      Dialog.confirm({
        message: this.$t('column.is_follow_user'),
        confirmButtonColor: '#AE2CF1',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        // on confirm
        const token = this.$route.query.token
        const room_id = this.$route.query.room_id
        this.loading = true
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=rankh5&act=rank_follow", {
          params : {
            token: token,
            to_user_id: this.list[i].user_id,
            room_id: room_id
          }
        }).then(res =>{
          // 加载状态结束
          if (res.data.status === 1) {
            this.list[i].is_follow = 1
          }else{
            Toast(res.data.error)
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    judgeIosAndroid,
    onClickRankingActive(name, title) {
      // 如果接口正在请求中，阻止切换
      if (this.loading_request) {
        this.$toast(this.$t('other.loading') || '加载中...')
        return
      }
      this.page = 1
      this.finished = false;
      this.ranking_active = name
      this.convert()
    },
    onClickRankingDay(name, title) {
      // 如果接口正在请求中，阻止切换
      if (this.loading_request) {
        this.$toast(this.$t('other.loading') || '加载中...')
        return
      }
      this.page = 1
      this.finished = false;
      this.day_active = name
      this.convert()
    },
    // 触摸开始
    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
    },
    // 触摸移动
    handleTouchMove(e) {
      this.touchEndX = e.touches[0].clientX
      this.touchEndY = e.touches[0].clientY
    },
    // 触摸结束
    handleTouchEnd() {
      // 如果接口正在请求中，禁止滑动切换
      if (this.loading_request) {
        return
      }
      
      const deltaX = this.touchEndX - this.touchStartX
      const deltaY = this.touchEndY - this.touchStartY
      
      // 判断是否为水平滑动（水平移动距离大于垂直移动距离，且大于50px）
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
        const currentIndex = this.day_tabs.indexOf(this.day_active)
        
        if (deltaX > 0) {
          // 向右滑动，切换到上一个tab
          if (currentIndex > 0) {
            this.day_active = this.day_tabs[currentIndex - 1]
            this.page = 1
            this.finished = false
            this.convert()
          }
        } else {
          // 向左滑动，切换到下一个tab
          if (currentIndex < this.day_tabs.length - 1) {
            this.day_active = this.day_tabs[currentIndex + 1]
            this.page = 1
            this.finished = false
            this.convert()
          }
        }
      }
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    JumpUserinfo(id) {
      console.log(id)
      if(id){
        // 拦截跳转用户主页面
        window.location.href="live://live?action=JumpUser&id=" + id
      }
    },
    SVGA() {
      this.$nextTick(()=>{
        this.list.map((v,i)=>{
          if (v.avatar_frame_url && i > 2 && !this.isWebP(v.avatar_frame_url)) {
            //这里动态给ID，列表
            var player = new SVGA.Player('#popular_svga'+v.user_id);
            var parser = new SVGA.Parser('#popular_svga'+v.user_id);
            //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
            console.log('svga======')
            console.log(v.avatar_frame_url)
            parser.load(v.avatar_frame_url, function(videoItem) {
              player.setVideoItem(videoItem);
              player.startAnimation();
            })
          }
        })
      })
    },
    convert() {
      // 标记接口开始请求
      this.loading_request = true
      
      // on confirm
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=rankh5&act=get_rank_list", {
        params : {
          token: token,
          rank_type: this.ranking_active,
          rank_name: this.day_active,
          p: this.page
        }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        // 加载状态结束
        this.loading = false
        this.loading_request = false // 标记接口请求完成
        
        if (res.data.status === 0) {
          Toast(res.data.error)
          this.finished = true
          return false
        }
        if (this.page == 1) {
          this.list = []
          this.finished = false
        }
        for(let i = 0; i< res.data.data.list.length; i ++) {
          res.data.data.list[i]['user_level'] =  require('../assets/img/level/wealth_level_'+res.data.data.list[i].user_level+'.png')
          res.data.data.list[i]['charm_level'] =  require('../assets/img/level/charm_level_'+res.data.data.list[i].charm_level+'.png')
          this.list.push(res.data.data.list[i])
        }
        this.diamonds_name = res.data.data.diamonds_name
        this.rank_user = res.data.data.user_rank
        this.rank_user['user_level'] =  require('../assets/img/level/wealth_level_'+this.rank_user.user_level+'.png')
        this.rank_user['charm_level'] =  require('../assets/img/level/charm_level_'+this.rank_user.charm_level+'.png')
        this.SVGA()
        // 数据全部加载完成
        if (res.data.data.list.length <= 0) {
          this.finished = true
        }
        this.page ++
      }).catch(err => {
        toast.clear(); // 关闭加载提示
        // 请求失败也要恢复状态
        this.loading = false
        this.loading_request = false
        Toast(this.$t('other.network_error') || '网络错误')
      })
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/rank_list.vue